export const STOCKS_DOMAIN_KEY = 'stocks';
